import React, { Component } from 'react'
import {renderParagraphs} from '../utils';
import {LinkBoxGrid} from '../LinkBoxGrid'

import './audition-excerpts.css'

class AuditionExcerpts extends Component {

  render () {
    let description = renderParagraphs(this.props.description);

    return (
      <div>
        <div className="subtitle">{this.props.title}</div>
        {description}

        <br></br>

        <LinkBoxGrid data = {this.props.excerpts} nCellsPerRow={3}></LinkBoxGrid>
      </div>
    );
  }
}


export default {AuditionExcerpts}



// WEBPACK FOOTER //
// ./src/components/AuditionExcerpts/index.js